import * as React from 'react';
import * as style from './style.css';

export const MainSection = ({ children }: React.PropsWithChildren) => {
  return <div className={style['container']}>{children}</div>;
};
